import {
  ADD_MULTI_ORDER,
  ADD_MULTI_ORDER_ITEM,
  MULTI_ORDER_ERROR,
  MULTI_ORDER_ERROR_RESET,
  RECEIVE_MULTI_ORDER_ENABLED,
} from '../../actions/multiOrders';
import { NAVIGATION_TO_LANDING_PAGE } from '../../actions/page';

export const initialState = {
  parent_order_number: null,
  simple_return: false,
  gift_return: false,
  locale: null,
  return_method: null,
  return_carrier: null,
  return_to_dc: null,
  orders: [],
  items: [],
  error: null,
  enabled: false,
  hasAdditionalOrders: false,
};

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case ADD_MULTI_ORDER:
      return {
        ...state,
        orders: [...state.orders, payload],
        hasAdditionalOrders: [...state.orders, payload].length > 0,
      };

    case ADD_MULTI_ORDER_ITEM: {
      return {
        ...state,
        items: [
          ...state.items.filter(
            (item) =>
              !(item.item_id === payload.item_id && item.order_number === payload.order_number),
          ),
          payload,
        ],
      };
    }

    case RECEIVE_MULTI_ORDER_ENABLED:
      return {
        ...state,
        enabled: payload,
      };

    case MULTI_ORDER_ERROR:
      return {
        ...state,
        error: payload,
      };

    case MULTI_ORDER_ERROR_RESET:
      return {
        ...state,
        error: null,
      };

    case NAVIGATION_TO_LANDING_PAGE:
      return {
        ...initialState,
        enabled: state.enabled,
      };

    default:
      return state;
  }
};
